module.exports = __webpack_public_path__ + "static/media/about_bg.fdef53e4.png";